import { Outlet, useLocation } from 'react-router-dom'
import { useAppSelector, useAppDispatch } from '@/hooks/storeHooks/storehooks'
import { TabProvider } from '@/contexts/TabContext'
import { changeMenuStatus } from '@/redux-store/slices/menuItemSlice/menuItemSlice'
import SidebarComponent from '../../containers/menubar/sidebar'
import Header from '../../containers/header/header'
import { WebTourProvider } from '../../contexts/WebTourContext'
import WebTour from '../../components/atom/WebTour/WebTour'

export const Layout: React.FC = () => {
  const dispatch = useAppDispatch()
  const mapIndex = useAppSelector(state => state.menu.isMap)
  const isSidebarOpen = useAppSelector(state => state.menu.menuExpanded)
  const toHideSideBar = useAppSelector(state => state.menu.toHideSideBar)
  const showSidebar = !mapIndex && !toHideSideBar
  const webtour = useAppSelector(state => state.menu.webtour)

  const location = useLocation()
  const pathParts = location.pathname.split('/')
  const page = pathParts[pathParts.length - 1]

  return (
    <WebTourProvider>
      <TabProvider>
        <div
          className='flex w-full overflow-hidden bg-info-dim'
          style={{ height: 'calc(var(--vh, 1dvh) * 100)' }}
        >
          {showSidebar && (
            <div
              className={`shrink-0 h-full relative ${isSidebarOpen && !webtour ? 'z-[1000]' : 'z-[60]'}`}
            >
              <SidebarComponent />
            </div>
          )}

          {/* Mobile backdrop when sidebar is open */}
          <div
            className={`fixed inset-0 bg-black/50 z-[999] md:hidden transition-opacity duration-150 ease-out ${
              isSidebarOpen
                ? 'opacity-100 pointer-events-auto'
                : 'opacity-0 pointer-events-none'
            }`}
            onClick={() => dispatch(changeMenuStatus(false))}
          />

          {/* Main content — flex-1 min-w-0 fills all remaining space */}
          <div className='flex-1 min-w-0 flex flex-col overflow-hidden'>
            {!mapIndex && <Header />}
            <main
              id='mainOutlerWrapper'
              className={`
                flex-1 min-h-0 w-full self-center overflow-hidden bg-tertiary
                ${page !== 'home' ? 'p-0 md:p-2' : 'pb-3'}
              `}
            >
              <Outlet />
            </main>
          </div>

          {/* Web Tour overlay — always mounted so it survives navigation */}
          <WebTour />
        </div>
      </TabProvider>
    </WebTourProvider>
  )
}
